import template from './giftcards.html';
import { FormActions } from 'core/services/form';
import giftcardsI18N from 'i18n/giftcards/es.json';
import { fechaRenderer } from 'core/util';
import { rest } from 'core/api';
import { formatErrorMessage } from 'core/util';


export let GiftcardsComponent = {
  templateUrl: template,
  selector: 'giftcards',
  bindings: {
    translations: '='
  },
  controller: GiftcardsCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(giftcardsI18N).concat(commonsI18N);

GiftcardsCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService', 'CustomModal'
];

function GiftcardsCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService, CustomModal) {

  Object.assign(this, { $state, $ngRedux, ngNotify });
  var defaultColumnOrder = ['codigo', 'servicio.nombre', 'monto', 'montoRestante', 'estado.value', 'vigenciaInicio', 'vigenciaFin'];

  BasicFactory.setup('giftcards');

  const monedaQuery = Filter.path('tipo.codigo').eq('moneda');
  const monedaUrl = encodeURI('valores?filter=' + JSON.stringify(monedaQuery));

  const estadoQuery = Filter.path('tipo.codigo').eq('estado_giftcard');
  const estadoUrl = encodeURI('valores?filter=' + JSON.stringify(estadoQuery));

  this.options = {
    resource: 'giftcards',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de giftcards'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'codigo', title: this.translations['Código'] },
      {
        data: 'servicio.nombre',
        title: this.translations['Nombre Servicio'],
        render: function(data, type, row) {
          return row.servicio ? row.servicio.nombre : '<i>No Aplica</i>';
        }
      },
      { data: 'monto', title: this.translations['Monto'], renderWith: 'monedaRender' },
      { data: 'montoRestante', title: this.translations['Monto Restante'], renderWith: 'monedaRender' },
      {
        data: 'moneda.value',
        title: this.translations['Moneda'],
        type: 'combo',
        filterUrl: monedaUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.moneda ? row.moneda.name : '<i>No establecido</i>';
        }
      },
      {
        data: 'estado.value',
        title: this.translations['Estado'],
        type: 'combo',
        filterUrl: estadoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.estado ? row.estado.name : '<i>No establecido</i>';
        }
      },
      { data: 'vigenciaInicio', title: this.translations['Inicio'], type: 'date-range' },
      { data: 'vigenciaFin', title: this.translations['Fin'], type: 'date-range' }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onRemove: onRemove.bind(this),
    onView: onView.bind(this),
    canEditCondition: canEdit.bind(this),
    canRemoveCondition: canRemove.bind(this),
    canCerrarSaldoPendienteCondition: canCerrarSaldoPendiente.bind(this),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-warning btn-dt" uib-tooltip="' + this.translations['Cerrar saldo pendiente'] + '" ng-show="options.canCerrarSaldoPendienteCondition(rowsData[<%= dataId %>])" ng-click="cerrarSaldoPendiente(rowsData[<%= dataId %>])"> <span class="glyph-icon icon-close" style="top: -8px;"></span></button>',
        functionName: 'cerrarSaldoPendiente',
        functionDef: (item) => {
          let self = this;
          CustomModal.open({
            title: 'Cerrar giftcard con saldo pendiente',
            id: item.id,
            message: '¿Está seguro de cerrar giftcard con saldo pendiente?',
            ok: function() {
              $ngRedux.dispatch(rest.actions.cerrarSaldoPendiente({ id: item.id }, {}, (err, data) => {
                if (!err) {
                  ngNotify.set(self.translations['Giftcard cerrada correctamente'], 'success');
                  self.options.reloadData();
                } else if (err) {
                  ngNotify.set(err.message, 'warn');
                }
              }));
            }
          });
        }
      }
    ]
  };

  function canEdit(data) {
    return (data.estado.value === 'Disponible Venta' && data.tipo.value !== 'Gentileza') ||
      (data.estado.value === 'Habilitada' && data.tipo.value === 'Gentileza') && AuthorizationService.hasPermission('update_giftcards');
  }

  function canRemove(data) {
    return (data.estado.value === 'Disponible Venta' && data.tipo.value !== 'Gentileza') ||
      (data.estado.value === 'Habilitada' && data.tipo.value === 'Gentileza') && AuthorizationService.hasPermission('delete_giftcards');
  }

  function canCerrarSaldoPendiente(data) {
    return (data.estado.value === 'Saldo Pendiente' && AuthorizationService.hasPermission('update_giftcards'));
  }

  this.mapStateToThis = mapStateToThis.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de giftcards']
    };
    this.form();
  };
  this.gotoForm = gotoForm.bind(this);


  function mapStateToThis(state) {

    if (state.form.removed) {
      this.ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }
    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    return { form: state.form };
  }

  function gotoForm() {
    this.$state.go('home.giftcards.new');
  }

  function onEdit(itemId) {
    this.$state.go('home.giftcards.uid.edit', { uid: itemId });
  }

  function onRemove(itemId) {
    this.remove('giftcards', itemId);
  }

  function onView(itemId) {
    this.$state.go('home.giftcards.uid.view', { uid: itemId });
  }
}


// WEBPACK FOOTER //
// ./src/components/giftcards/list/giftcards.component.js